import { render, staticRenderFns } from "./SFormElement.vue?vue&type=template&id=d9f88c42&scoped=true&"
import script from "./SFormElement.vue?vue&type=script&lang=ts&"
export * from "./SFormElement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9f88c42",
  null
  
)

export default component.exports